<template>
  <div :class="['survey__wrapper', { '-expired': isExpired }]">
    <div class="detail">
      <div>
        <div class="name">
          <strong>{{ surveyName }}</strong>
          <v-chip v-if="isDefault" color="primary" outline small style="font-size: 12px">{{
            $t('set_default')
          }}</v-chip>
          <v-chip v-if="isExpired" color="black" small style="font-size: 12px; color: #fff">{{
            $t('EXPIRED')
          }}</v-chip>
        </div>
        <strong style="font-size: 12px">{{ $t('Response Message') }}: </strong>
        <span class="message">{{ message }}</span>
      </div>
      <small>{{ $t('update_at') }}: {{ updatedAt | DateFormat('DD/MM/YYYY hh:mm A') }}</small>
    </div>
    <div class="action">
      <v-btn icon outline color="primary" class="ma-0" @click="showPreview = true">
        <v-icon small>visibility</v-icon>
      </v-btn>
      <template v-if="isEdit">
        <v-btn icon outline color="primary" class="ma-0" @click="$emit('edit')">
          <v-icon small>edit</v-icon>
        </v-btn>
        <v-btn icon outline color="primary" class="ma-0" @click="$emit('delete')">
          <v-icon small>delete</v-icon>
        </v-btn>
      </template>
    </div>
    <PreviewMessage v-if="showPreview" :messages="previewMessage" @close="showPreview = false" />
  </div>
</template>
<script>
import PreviewMessage from '@/components/elements/PreviewMessage'
import dayjs from 'dayjs'
export default {
  components: { PreviewMessage },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    buttonName: {
      type: String,
      default: ''
    },
    surveyId: {
      type: String,
      default: ''
    },
    surveyName: {
      type: String,
      default: ''
    },
    createdAt: {
      type: String,
      default: ''
    },
    updatedAt: {
      type: String,
      default: ''
    },
    isDefault: {
      type: Boolean,
      default: false
    },
    expiredAt: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showPreview: false
    }
  },
  computed: {
    previewMessage() {
      return [
        [
          {
            text: this.message,
            buttons: [
              {
                title: this.buttonName
              }
            ],
            type: 'button'
          }
        ]
      ]
    },
    isExpired() {
      return dayjs(this.expiredAt).isBefore(dayjs())
    }
  }
}
</script>
<style lang="scss" scoped>
.survey__wrapper {
  border: 1px solid #c1c1c1;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  gap: 4px;
  &.-expired {
    background: #f9f9f9;
    opacity: 0.7;
  }
  .detail {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    word-break: break-word;
    .name {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 4px;
      gap: 4px;
    }
    strong {
      color: #000;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .message {
      font-size: 12px;
      color: #333;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      margin-bottom: 4px;
    }
    small {
      color: #9e9e9e;
    }
  }
  .action {
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/CustomerSupportService/SurveyCard.vue